export const API_CONFIG = {
  BASE_URL: "https://api.snapstay.co/api/",
  TIMEOUT: 30000,
} as const;
